module.exports = __webpack_public_path__ + "static/media/gonzalez_nelson.24abf424.jpg";